import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./UnitContainer')).UnitContainer,
  'unitContainer',
  {
    routeParams: '=',
  },
);
